import React from "react";
import { Wrapper } from "./LeaderBoard.styled";
import LeaderBoardComponenet from "components/pageSection/LeaderBoard/Leaderboard";


const LeaderBoard = () => {
  return (
    <Wrapper>
     <LeaderBoardComponenet/>
    </Wrapper>
  );
};

export default LeaderBoard;
